import { TSupportedLocale } from "src/domains/storefront/storefront-types"

export const SUPPORTED_LANGUAGES: TSupportedLocale[] = [
  "en",
  "de",
  "es",
  "fr",
  "it",
  "ja",
  "pt",
]
export const DEFAULT_LANGUAGE: TSupportedLocale = "en"
